import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import { BiUserPlus } from 'react-icons/bi';
import { arrayIncludes } from '@material-ui/pickers/_helpers/utils';

let BasicTable = (props) => {
    const returnHeaders = () => {
        return (
            props.headers.map(header => {
                return (<th className='basic-table-style' >{header
                }</th>)
            })
        )
    }
    const returnBody = () => {
        return props.data.map((element, index1) => {
            {
                return (
                    Object.keys(element).map(key => {
                        return (<td className='basic-table-style'>
                            {element[key]}
                        </td>)
                    })
                )
            }
        })

    }
    return (
        <div>
            <table className='basic-table-style'>
                <tr className='basic-table-style'>
                    {returnHeaders()}
                </tr>
                {returnBody()}
            </table>
        </div>
    );
}

export default BasicTable;

  